// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"f97b9d2e","821":"11272995"}[chunkId] + ".chunk.js";
};